import React, { useContext } from 'react';
import { Stepper } from '@design-system-coopeuch/web';
import StepperContext from './StepperContext';

// styles
import { StyledWrapperStepper } from './styles';
import './styles.css';

const stepsEnrollment = [
  { step: 1, name: 'Datos personales' },
  { step: 2, name: 'Contratación y pago' },
  // { step: 3, name: 'Adicionales' },
  { step: 3, name: 'Comprobante y adicionales' },
];

const StepperEnrollment = () => {
  const { step: currentStep } = useContext(StepperContext);

  return (
    <StyledWrapperStepper>
      <Stepper currentStep={currentStep} steps={stepsEnrollment} />
    </StyledWrapperStepper>
  );

};

export default StepperEnrollment;
